import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
// @ts-ignore
import ProductImageGallery from '@sprinx/react-com/ProductImageGallery';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import ChipColored from '@sprinx/react-mui-components/ChipColored';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { ProductDetailProduct } from '../../../api/products/productDetail';
import useProductAdornmentsMapper from '../../../api/products/useProductAdornmentsMapper';

export interface ProductDetailImageGalleryProps extends StandardDivProps<ProductDetailImageGalleryClassKey> {
  product: ProductDetailProduct;
}

export type ProductDetailImageGalleryClassKey =
  | 'root'
  | 'gelleryImage'
  | 'gelleryPrimaryImage'
  | 'gelleryDialogPrimaryImage'
  | 'horizontal'
  | 'modalContent'
  | 'outletChipWrapper';

const themeSettings = { name: 'ProductDetailImageGallery' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<ProductDetailImageGalleryClassKey, {}>({
      root: {},
      gelleryImage: {
        height: (theme.spacing(38) * 3) / 4,
        width: theme.spacing(38),
      },
      gelleryPrimaryImage: {
        height: (theme.spacing(38) * 3) / 4,
        width: theme.spacing(38),
      },
      gelleryDialogPrimaryImage: {
        height: (theme.spacing(100) * 3) / 4,
        width: theme.spacing(100),
        [theme.breakpoints.down('md')]: {
          height: (theme.spacing(75) * 3) / 4,
          width: theme.spacing(75),
        },
        [theme.breakpoints.down('sm')]: {
          height: (theme.spacing(44) * 3) / 4,
          width: theme.spacing(44),
        },
        [theme.breakpoints.down('xs')]: {
          height: (theme.spacing(24) * 3) / 4,
          width: theme.spacing(24),
        },
      },
      modalContent: {
        [theme.breakpoints.down('sm')]: {
          display: 'flex',
          flexDirection: 'column',
          minHeight: '60vh',
        },
      },
      horizontal: {
        margin: 'auto',
      },
      outletChipWrapper: {
        '& .MuiChip-label': {
          color: `${theme.palette.common.white} !important`,
          fontWeight: 600,
        },
      },
    }),
  themeSettings,
);

const ProductDetailImageGallery = React.forwardRef<HTMLDivElement, ProductDetailImageGalleryProps>(
  ({ className, classes: pClasses, product }, ref) => {
    const classes = useStyles({ classes: pClasses });
    const theme = useTheme();
    const isBelowSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const imegeAdornments = useProductAdornmentsMapper('detail', product.adornments, product);

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        {product.taxonomies?.includes('/catalogue/outlet') && (
          <span className={classes.outletChipWrapper}>
            <ChipColored label='OUTLET' color='#FFA800' size='small' />
          </span>
        )}
        <ProductImageGallery
          adornments={imegeAdornments}
          product={product as any}
          classes={{
            image: classes.gelleryImage,
          }}
          PrimaryImageProps={{
            ProductImageProps: {
              classes: {
                'size-big-landscape': classes.gelleryPrimaryImage,
              },
            },
          }}
          // @ts-ignore
          ProductImageModalProps={{
            ProductImageThumnailsProps: {
              variant: isBelowSmall ? 'horizontal' : 'vertical',
              classes: {
                horizontal: classes.horizontal,
              },
            },
            ProductImageDecoratedProps: {
              ProductImageProps: {
                classes: {
                  'size-big-landscape': classes.gelleryDialogPrimaryImage,
                },
              },
            },
            classes: {
              content: classes.modalContent,
            },
          }}
        />
      </div>
    );
  },
);

ProductDetailImageGallery.displayName = 'ProductDetailImageGallery';

export default withThemeProps(themeSettings)(ProductDetailImageGallery);
